import { deleteSession } from "./session";
import { clearPersistedState } from "../store/sagaStore";
import { clearStockManagerAllowedCategoriesCache } from "./allowedCategories";
import { getAuth, signOut } from "@firebase/auth";
import { resetAuthState } from "./firebaseAuth";
import * as Sentry from "@sentry/react";

export const logout = async () => {
  // Reset Firebase auth utility state
  resetAuthState();
  // Sign out from Firebase first (clears IndexedDB auth state)
  try {
    const auth = getAuth();
    if (auth.currentUser) {
      await signOut(auth);
    }
  } catch (error) {
    Sentry.captureException(error, {
      level: "warning",
      tags: { auth_flow: "logout_firebase_signout" },
    });
  }

  // Clear all session data
  deleteSession("customToken");
  deleteSession("idToken");
  deleteSession("userId");
  deleteSession("role");
  deleteSession("lastRequestTime");

  // Drop the stock manager's cached allowed-categories entries.
  clearStockManagerAllowedCategoriesCache();

  // Clear persisted Redux state before clearing all localStorage
  clearPersistedState();
  
  // Clear Sentry user context
  Sentry.setUser(null);
  
  // Clear all localStorage
  localStorage.clear();
  
  // Redirect to login
  window.location.href = "/login";
};
